import { produce } from 'immer'
import { Pagination } from '@pepper/ui'
import { NUMBER_OF_LIST_PER_PAGE } from '@pepper/utils/src/constant/form/form'

import styles from './_.module.css'

type FooterProps = {
  total: number
  queryParamFilters: any
  type: 'projects' | 'items'
  setQueryParamFilters: any
}

export const Footer = ({
  total,
  queryParamFilters,
  type,
  setQueryParamFilters,
}: FooterProps): JSX.Element => {
  const { currentPage, limit: pageSize } = queryParamFilters
  const from = currentPage ? currentPage * pageSize + 1 : 1
  const _itemsRangeText = `Showing ${from} to ${
    currentPage * pageSize + pageSize < total
      ? currentPage * pageSize + pageSize
      : total
  } of ${total} ${type === 'projects' ? 'Projects' : 'Items'}`

  const handlePageChange = (page: number, size?: number) => {
    const nextQueryParamFilters = produce(
      queryParamFilters,
      (draftState: any) => {
        draftState.currentPage = page - 1
      }
    )
    setQueryParamFilters({ ...nextQueryParamFilters, limit: size })
  }

  const handleSizeChange = (_: number, size: number) => {
    setQueryParamFilters({ limit: size })
  }

  return (
    <div className={styles.footer}>
      <span>{total > 0 && _itemsRangeText}</span>

      <Pagination
        current={queryParamFilters.currentPage + 1}
        className={styles.pagination}
        pageSize={pageSize}
        pageSizeOptions={NUMBER_OF_LIST_PER_PAGE}
        total={total}
        hideOnSinglePage={true}
        showSizeChanger={true}
        onChange={handlePageChange}
        onShowSizeChange={handleSizeChange}
        size="small"
      />
    </div>
  )
}
